import Dropdown from "react-bootstrap/Dropdown";

export default function DropdownMenu({
  placeholder,
  selectedValue,
  selectValue,
  list,
  disabled
}) {
  return (
    <Dropdown className="option-dropdown mb-3">
      <Dropdown.Toggle
        variant=""
        id="dropdown-basic"
        className="btn-question-type"
        disabled={disabled}
      >
        {selectedValue || placeholder}
      </Dropdown.Toggle>
      <Dropdown.Menu className="pra-dropdown edit-dropdown">
        {Object.keys(list).map((item, index) => {
          return (
            <Dropdown.Item
              key={index}
              onSelect={selectValue}
              eventKey={item}
              className="menu_option pra-drop-list edit_option"
            >
              {list[item]}
              <div>
                <input type="radio" name="radio" />
                <span></span>
              </div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
}
